import { render, staticRenderFns } from "./MarketMyListDisplay.vue?vue&type=template&id=c88c00fc&scoped=true&"
import script from "./MarketMyListDisplay.vue?vue&type=script&lang=js&"
export * from "./MarketMyListDisplay.vue?vue&type=script&lang=js&"
import style0 from "./MarketMyListDisplay.vue?vue&type=style&index=0&id=c88c00fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88c00fc",
  null
  
)

export default component.exports